import { instance } from './config';

export const getVendorAccounts = () => {
   return instance.get('/vendor');
};

export const createVendor = (requestData) => {
   return instance.post('/vendor', requestData);
};

export const getVendorAccountById = (id) => {
   return instance.get(`/vendor/${id}`);
};
export const createVendorAccountRecharge = (requestData) => {
   return instance.post('/vendor/recharge', requestData);
};

export const getVendorAccountRechargesById = (vendorAccountId) => {
   return instance.get(`/vendor/recharge/${vendorAccountId}`);
};
